import WiseView from './WiseView.vue';
import { frontendURL } from '../../../helper/URLHelper';

const WiseRouteStub = {
  name: 'WiseRouteStub',
  render: () => null,
};

const wiseChild = (path, name) => ({
  path,
  name,
  roles: ['administrator', 'agent', 'supervisor'],
  component: WiseRouteStub,
});

export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise'),
    name: 'wise',
    roles: ['administrator', 'agent', 'supervisor'],
    component: WiseView,
    children: [
      {
        path: '',
        redirect: { name: 'wise_dashboard' },
      },
      wiseChild('dashboard', 'wise_dashboard'),
      wiseChild('createmessage', 'create_message'),
      wiseChild('editmessage', 'edit_message'),
      wiseChild('connection', 'connection_wise'),
      wiseChild('profile-wise', 'profile_wise'),
      wiseChild('integrations-wise', 'integrations_wise'),
    ],
  },
];
